import { render, staticRenderFns } from "./DetailsButtons.vue?vue&type=template&id=6a6a0927&"
import script from "./DetailsButtons.vue?vue&type=script&lang=js&"
export * from "./DetailsButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports